export const RESTAURANT = {
  name: "Segreto Ristorante Italiano",
  shortName: "Segreto",
  tagline: "Włoski sekret w sercu Katowic",
  phone: "+48 518 805 767",
  phoneRaw: "+48518805767",
  address: {
    street: "ul. Henryka Mikołaja Góreckiego 13/2U",
    postal: "40-206 Katowice",
    city: "Katowice",
    country: "Poland",
    district: "Pierwsza Dzielnica",
  },
  hours: [
    { day: "Poniedziałek", value: "Zamknięte" },
    { day: "Wtorek",       value: "14:00 – 22:00" },
    { day: "Środa",        value: "14:00 – 22:00" },
    { day: "Czwartek",     value: "14:00 – 22:00" },
    { day: "Piątek",       value: "14:00 – 22:00" },
    { day: "Sobota",       value: "12:00 – 22:00" },
    { day: "Niedziela",    value: "12:00 – 22:00" },
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=Henryka+Mikołaja+Góreckiego+13,+40-206+Katowice&output=embed",
  mapsLink:
    "https://maps.app.goo.gl/CkjfJyAdpsEWdnhi9?g_st=ic",
  social: {
    instagram: "https://www.instagram.com/segreto_katowice?igsh=YTRneGN1NXVyZWt4",
    facebook:  "https://www.facebook.com/share/14bTjv1oH9Y/?mibextid=wwXIfr",
    maps:      "https://maps.app.goo.gl/CkjfJyAdpsEWdnhi9?g_st=ic",
  },
};

export const IMAGES = {
  heroEvening:
    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/07amoa0v_IMAGE%202026-06-07%2016%3A14%3A11.jpg",
  muralDay:
    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/07amoa0v_IMAGE%202026-06-07%2016%3A14%3A11.jpg",
  pasta:
    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/ldjdmbzs_IMAGE%202026-06-07%2013%3A05%3A49.jpg",
  tiramisu:
    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/cdhioiqk_IMAGE%202026-06-07%2013%3A06%3A02.jpg",
  logo:
    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/4kfn4jwj_IMAGE%202026-06-07%2013%3A06%3A51.jpg",
  bar:        "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/xqpfx8ht_IMAGE%202026-06-07%2015%3A06%3A51.jpg",
  terrace:    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/2gvo71v1_IMAGE%202026-06-07%2015%3A07%3A09.jpg",
  signage:    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/j2rormmg_IMAGE%202026-06-07%2015%3A07%3A27.jpg",
  awards1:    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/h4u2t5iw_IMAGE%202026-06-07%2015%3A07%3A48.jpg",
  interiorBar:"https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/bto37jnw_IMAGE%202026-06-07%2015%3A08%3A15.jpg",
  awards2:    "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/y7otl7ad_IMAGE%202026-06-07%2016%3A00%3A40.jpg",
  aperi:      "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/jmzovssc_IMAGE%202026-06-07%2016%3A00%3A50.jpg",
  bar2:       "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/0ce715j0_IMAGE%202026-06-07%2016%3A01%3A22.jpg",
  entry:      "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/gcqueqsh_IMAGE%202026-06-07%2016%3A01%3A46.jpg",
  menuTable:  "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/en3181zo_IMAGE%202026-06-07%2016%3A02%3A17.jpg",
  pizzaCard:  "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/5tj25cp2_tg_image_1581353394.jpeg",
  shrimpCard: "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/zmt8lf39_tg_image_2235018006.jpeg",
  pastaCard:  "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/nbgm0mhh_tg_image_2038597416.jpeg",
  beerCard:   "https://customer-assets.emergentagent.com/job_segreto-dining/artifacts/a6ew9k1g_tg_image_1654659884.jpeg",
};

export const NAV = [
  { to: "/",          label: "Start" },
  { to: "/o-nas",     label: "O nas" },
  { to: "/menu",      label: "Menu" },
  { to: "/galeria",   label: "Galeria" },
  { to: "/kontakt",   label: "Kontakt" },
];
